import React, { useEffect, useRef, useState } from "react";
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
  TooltipProvider,
} from "@/components/ui/tooltip";
import { Typography } from "@/components/ui/typography";

type TruncatedTableCellProps = {
  content: string;
  className?: string;
};

export const TruncatedTableCell: React.FC<TruncatedTableCellProps> = ({
  content,
  className = "",
}) => {
  const textRef = useRef<HTMLDivElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const checkTruncation = () => {
      if (!textRef.current) return;
      setIsTruncated(textRef.current.scrollWidth > textRef.current.clientWidth);
    };

    const timeoutId = setTimeout(checkTruncation, 0);
    window.addEventListener("resize", checkTruncation);
    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("resize", checkTruncation);
    };
  }, [content]);

  const cellContent = (
    <div
      ref={textRef}
      className={`truncate whitespace-nowrap overflow-hidden ${className} ${
        isTruncated ? "cursor-pointer" : ""
      }`}>
      {content}
    </div>
  );

  if (!isTruncated) return cellContent;

  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>{cellContent}</TooltipTrigger>
        <TooltipContent
          side='top'
          align='start'
          className='max-w-xs bg-gray-700 text-grey-100 break-words z-50'>
          <Typography variant='regular-12' className='text-gray-100'>
            {content}
          </Typography>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

